import { html, nothing } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BoilerplateModal } from './boilerplate_modal';

class ModalGiveawayForm extends BoilerplateModal {
  constructor() {
    super();
    this.fromBottom = true;
  }

  static get properties() {
    return {
      ...super.properties,
      giveawayHandle: { type: String, attribute: 'giveaway-handle' },
      countries: { type: String, attribute: 'countries' },
      customerDetails: { type: String, attribute: 'customer-details' },
      additionalEntryLink: { type: String, attribute: 'additional-entry-link' },
      shopNowLink: { type: String, attribute: 'shop-now-link' },
      shopSuccessLink: { type: String, attribute: 'shop-success-link' },
      shopSuccessLabel: { type: String, attribute: 'shop-success-label' },
      shopSuccessAriaLabel: {
        type: String,
        attribute: 'shop-success-aria-label',
      },
      colour: { type: String, attribute: 'colour' },
      amount: { type: String, attribute: 'amount' },
      action: { type: String, attribute: 'action' },
      token: { type: String, attribute: 'token' },
      value: { type: String, attribute: 'value' },
      region: { type: String, attribute: 'region' },
      privacyDisclaimerHtml: {
        type: String,
        attribute: 'privacy-disclaimer-html',
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();

    this._handleInnerClose = this.handleInnerClose.bind(this);
    document.addEventListener('modal-giveaway-form:close', this._handleInnerClose);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('modal-giveaway-form:close', this._handleInnerClose);
  }

  handleInnerClose() {
    if (this.open) {
      this.toggleModal();
    }
  }

  renderBody() {
    if (!this.open) {
      return nothing;
    }

    return html`
      <giveaway-form
        class="modal_giveaway_form_inner"
        giveaway-handle="${ifDefined(this.giveawayHandle || undefined)}"
        countries="${ifDefined(this.countries || undefined)}"
        customer-details="${ifDefined(this.customerDetails || undefined)}"
        additional-entry-link="${ifDefined(this.additionalEntryLink || undefined)}"
        shop-now-link="${ifDefined(this.shopNowLink || undefined)}"
        shop-success-link="${ifDefined(this.shopSuccessLink || undefined)}"
        shop-success-label="${ifDefined(this.shopSuccessLabel || undefined)}"
        shop-success-aria-label="${ifDefined(this.shopSuccessAriaLabel || undefined)}"
        action="${ifDefined(this.action || undefined)}"
        method="POST"
        enctype="application/json"
        token="${ifDefined(this.token || undefined)}"
        value="${ifDefined(this.value || undefined)}"
        region="${ifDefined(this.region || undefined)}"
        colour="${ifDefined(this.colour || undefined)}"
        amount="${ifDefined(this.amount || undefined)}"
        privacy-disclaimer-html="${ifDefined(this.privacyDisclaimerHtml || undefined)}"
        simple
      ></giveaway-form>
    `;
  }
}

window.customElements.get('modal-giveaway-form') ||
  window.customElements.define('modal-giveaway-form', ModalGiveawayForm);
